// import React, { useState } from "react";

// const ProgressTab = ({
//   tabs,
//   initialActiveTab = 0,
//   initialActiveSlide = 0,
// }) => {
//   const [activeTab, setActiveTab] = useState(initialActiveTab);
//   const [activeSlide, setActiveSlide] = useState(initialActiveSlide);

//   return (
//     <div>
//       <div className="tab-container flex flex-1 flex-col overflow-hidden">
//         <div className="w-full max-w-7xl  flex justify-between  m-auto mt-10 overflow-auto">
//           {tabs.map((tab, index) => (
//             <React.Fragment key={index}>
//               <div className="tab-item flex flex-col gap-2 justify-between items-center relative pb-5 select-none">
//                 <div className="w-5 h-2 flex items-center justify-center">
//                   {activeTab === index && (
//                     <span class="material-symbols-outlined">
//                       arrow_drop_down
//                     </span>
//                   )}
//                 </div>
//                 <div
//                   className={`w-6 flex justify-center items-center rounded-full aspect-square text-xs border-[1px] ${
//                     activeSlide >= index
//                       ? "bg-primary border-primary text-white"
//                       : "border-gray-500 text-gray-500"
//                   }
//                   ${activeSlide >= index ? "cursor-pointer " : ""}
//                   `}
//                   onClick={
//                     activeSlide >= index ? () => setActiveTab(index) : () => {}
//                   }
//                 >
//                   {/* {activeSlide - 1 === index ? (
//                     index + 1
//                   ) : (

//                   )} */}

//                   {index <= activeSlide - 1 ? (
//                     <span class="material-symbols-outlined text-xs">check</span>
//                   ) : (
//                     index + 1
//                   )}
//                 </div>
//                 <div className="">
//                   <div
//                     className={`text-xs top-0 w-20 font-semibold  text-center  `}
//                   >
//                     {tab.title}
//                   </div>
//                 </div>
//               </div>
//               {index !== tabs.length - 1 && (
//                 <div
//                   className={`h-0.5 w-full  self-center -mt-6 min-w-10   ${
//                     activeSlide > index ? "bg-primary" : " bg-gray-300"
//                   }`}
//                 />
//               )}
//             </React.Fragment>
//           ))}
//         </div>
//         <div
//           role="tabpanel"
//           className="tab-content flex flex-1 overflow-hidden"
//         >
//           {tabs[activeTab].page}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProgressTab;

import React, { useState } from "react";

const ProgressTab = ({
  tabs,
  initialActiveTab = 0,
  initialActiveSlide = 0,
  setTabIndex,
}) => {
  const handleChnage = (index) => {
    if (setTabIndex) {
      setTabIndex(index);
    }
  };
  return (
    <div>
      <div className="tab-container flex flex-1 flex-col overflow-hidden">
        <div className="w-full max-w-7xl  flex justify-between  m-auto mt-10 overflow-auto">
          {tabs.map((tab, index) => (
            <React.Fragment key={index}>
              <div className="tab-item flex flex-col gap-2 justify-between items-center relative pb-5 select-none">
                <div className="w-5 h-2 flex items-center justify-center">
                  {initialActiveTab === index && (
                    <span class="material-symbols-outlined">
                      arrow_drop_down
                    </span>
                  )}
                </div>
                <div
                  className={`w-6 flex justify-center items-center rounded-full aspect-square !text-xs border-[1px] ${
                    initialActiveSlide >= index
                      ? "bg-primary border-primary text-white"
                      : "border-gray-500 text-gray-500"
                  }
                  ${initialActiveSlide >= index ? "cursor-pointer " : ""}
                  `}
                  onClick={
                    initialActiveSlide >= index
                      ? () => handleChnage(index)
                      : () => {}
                  }
                >
                  {/* {activeSlide - 1 === index ? (
                    index + 1
                  ) : (
                    
                  )} */}

                  {index <= initialActiveSlide - 1 ? (
                    <span class="material-symbols-outlined !text-xs">
                      check
                    </span>
                  ) : (
                    index + 1
                  )}
                </div>
                <div className="">
                  <div
                    className={`text-xs top-0 w-20 font-semibold  text-center  `}
                  >
                    {tab.title}
                  </div>
                </div>
              </div>
              {index !== tabs.length - 1 && (
                <div
                  className={`h-0.5 w-full  self-center -mt-6 min-w-10   ${
                    initialActiveSlide > index ? "bg-primary" : " bg-gray-300"
                  }`}
                />
              )}
            </React.Fragment>
          ))}
        </div>
        <div
          role="tabpanel"
          className="tab-content flex flex-1 overflow-hidden"
        >
          {tabs[initialActiveTab].page}
        </div>
      </div>
    </div>
  );
};

export default ProgressTab;
